var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomerimg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_30-User-Location",
    "data-name": "30-User-Location",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.868,
    height: 47.849,
    viewBox: "0 0 41.868 47.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M22.429,47.849H1.5a1.5,1.5,0,0,1-1.5-1.5V43.364c0-3.873,5.667-5.562,7.028-5.981L17.944,33.36V31.267a12.067,12.067,0,0,1-5.981-9.211,2.991,2.991,0,0,1-1.5-2.617V16.448a2.991,2.991,0,0,1,1.5-2.587v-1.9a11.962,11.962,0,0,1,23.925,0v1.9a2.991,2.991,0,0,1,1.5,2.587v2.991H34.392V16.448a1.5,1.5,0,0,1-1.5-1.5V11.962a8.972,8.972,0,1,0-17.944,0v2.991a1.5,1.5,0,0,1-1.5,1.5v2.991a1.5,1.5,0,0,1,1.5,1.5,8.972,8.972,0,0,0,5.129,8.09,1.5,1.5,0,0,1,.852,1.346v4.022a1.5,1.5,0,0,1-.972,1.406L8,40.283H7.835c-1.974.538-4.845,1.914-4.845,3.08v1.5H22.429Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M25.476,35.439a1.5,1.5,0,0,1-1.062-.434C18,28.65,18,23.686,18,23.476a7.476,7.476,0,0,1,14.953,0c0,.209,0,5.174-6.415,11.529A1.5,1.5,0,0,1,25.476,35.439ZM20.991,23.476c0,.15.209,3.589,4.486,8.314,4.336-4.83,4.486-8.314,4.486-8.314a4.486,4.486,0,0,0-8.972,0Z",
    transform: "translate(8.915 7.925)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 3,
    height: 3,
    transform: "translate(33 30)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerimg);
export default __webpack_public_path__ + "static/media/customerimg.8e386e2e82b88ccfd1bfae4aac680c3c.svg";
export { ForwardRef as ReactComponent };